import React, { Component } from "react";
import Icons from '../../icon';
import './icon-tab.style.css'

class IconTab extends Component {
  constructor(props) {
         super(props);
         this.state = {
            
         }
     }

     getIcon() {
        const { icon,color } = this.props;
        return <Icons customClassName={color} name={icon} size="24px" />;
      }

  render() {
    const { title, disabled, isActive, onClick, lastIcon } = this.props;

    return (
      <div
        className={`icon-tab__item transition-all ${disabled ? 'disabled' : ''} ${isActive ? "icon-tab__active" : ""}`}
        onClick={onClick}
      >
        {lastIcon && <div className="icon-tab__line"></div> }
        <div className="icon-tab__icon flex-shrink-0 p-2 mb-2">
          {this.getIcon()}
        </div>
        <div className="text-center">
          <h3
            className={`icon-tab__title`}
          >
            {title}
          </h3>
        </div>
      </div>
    );
  }
}

export default IconTab;
